module.exports = __webpack_public_path__ + "static/media/gen-03.8a31db40.png";